import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TriviaFormComponent } from '../components/Form';
import * as actions from '../actions';
import * as selectors from '../selectors';

class TriviaFormContainer extends Component {
  static propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    points: PropTypes.number,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
    selectChoice: PropTypes.func.isRequired,
    answer: PropTypes.shape({
      // eslint-disable-line react/no-unused-prop-types
      timeRemaining: PropTypes.number.isRequired,
      selectedChoice: PropTypes.string.isRequired,
    }),
    answerTimeout: PropTypes.number,
  };

  static defaultProps = {
    id: null,
    title: '',
    points: 0,
    choices: [],
    answer: null,
    answerTimeout: 10000,
  };

  state = {
    selectedValue: null,
    timeRemainingToAnswer: this.props.answerTimeout,
    disabled: false,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;

    if (props.answer) {
      const { timeRemaining, selectedChoice } = props.answer;
      newState = {
        selectedValue: selectedChoice,
        timeRemainingToAnswer: timeRemaining,
        disabled: true,
      };
    }

    return newState;
  }

  componentDidMount() {
    if (!this.state.disabled) {
      this.answerTimer = setInterval(this.answerTimerTick, 1000);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state !== nextState;
  }

  componentWillUnmount() {
    this.clearAnswerTimer();
  }

  answerTimer;
  clearAnswerTimer = () => {
    clearInterval(this.answerTimer);
  };

  answerTimerTick = () => {
    const nextTick = this.state.timeRemainingToAnswer - 1000;
    if (nextTick > 0) {
      this.setState({ timeRemainingToAnswer: nextTick });
    } else {
      this.setState({ disabled: true, timeRemainingToAnswer: 0 });
      this.clearAnswerTimer();
      this.props.clear();
    }
  };

  handleChoiceSelect = (selectedValue) => {
    const { id, selectChoice } = this.props;
    const { timeRemainingToAnswer } = this.state;

    selectChoice(id, selectedValue, timeRemainingToAnswer);

    this.setState({ disabled: true, selectedValue });
    this.clearAnswerTimer();
  };

  render() {
    const { title, points, choices, answerTimeout, ...props } = this.props;

    const { selectedValue, timeRemainingToAnswer, disabled } = this.state;

    return (
      <TriviaFormComponent
        title={title}
        points={points}
        choices={choices}
        timeRemainingToAnswer={timeRemainingToAnswer}
        answerTimeout={answerTimeout}
        selectedValue={selectedValue}
        disabled={disabled}
        handleChoiceSelect={this.handleChoiceSelect}
        {...props}
      />
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  answer: selectors.answer(state, ownProps),
  answerTimeout: selectors.answerTimeout(state, ownProps),
  id: selectors.id(state, ownProps),
  title: selectors.title(state, ownProps),
  choices: selectors.choices(state, ownProps),
  points: selectors.points(state, ownProps),
});
const mapDispatchToProps = {
  clear: actions.clear,
  selectChoice: actions.selectChoice,
};

export const TriviaForm = connect(mapStateToProps, mapDispatchToProps)(TriviaFormContainer);
